import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Button, Icon } from 'components/patterns'

export const StyledViewWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

export const StyledHeader = styled.div`
  border-bottom: 1px solid ${themeColor('sAndGTableHeaderBorderColor')};
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
`

export const StyledChevronCaret = styled(Icon)((props) => {
  const { defaultDrawerWidth } = props
  return `
    margin-right: 4px;
    ${
      defaultDrawerWidth
        ? `transform: rotate(180deg);`
        : `transform: rotate(0deg);`
    }
  `
})

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto;
  &:hover {
    text-decoration: none;
  }
  svg {
    height: 12px !important;
  }
`

export const ReadonlyChip = styled.span(
  (props) => `
    border: 1px solid ${themeColor('solidGrey', props)};
    padding: 2px 4px;
    border-radius: 4px;
    margin-bottom: 8px;
    font-size: 12px;
    margin-left: 8px;
    color: ${themeColor('solidGrey', props)};
  `
)

export const StyledTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
`

export const StyledStagingSaveErrorMessage = styled.span(
  (props) => `
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0;
    width: 232px;
    align-self: center;
    height: 32px;
    color: ${themeColor('blackSecondary', props)};
    position: absolute;
    top: 8px;
    left: 71px;
  `
)
